import { createEmpty, extend, isEmpty, buffer } from 'ol/extent'
import { transformExtent } from 'ol/proj'
import type { Extent } from 'ol/extent'
import type { LayerInfo } from './capabilities'

/**
 * Union of the advertised layer bounding boxes in map projection —
 * the viewer's initial extent (PRD P0.6).
 */
export function unionExtent3857(infos: LayerInfo[]): Extent | null {
  const union = createEmpty()
  for (const info of infos) {
    if (!info.extent4326) continue
    // Clamp away from the poles: web-mercator cannot represent |lat| ≥ 90.
    const [w, s, e, n] = info.extent4326
    const safe: Extent = [
      Math.max(w, -179.9),
      Math.max(s, -85),
      Math.min(e, 179.9),
      Math.min(n, 85),
    ]
    extend(union, transformExtent(safe, 'EPSG:4326', 'EPSG:3857'))
  }
  if (isEmpty(union)) return null
  return buffer(union, Math.max((union[2] - union[0]) * 0.03, 10000))
}
